// extracted by mini-css-extract-plugin
export default {"status":"styles_status__pkZFZ","failure":"styles_failure__C3QvC","success":"styles_success__clshZ","copyBtn":"styles_copyBtn__oJFXg","paginationBtn":"styles_paginationBtn__PPUHI"};